/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon } from 'components'
import styles from './FavoriteButton.module.scss'

const FavoriteButton = ({ value, onClick }) => (
  <Button type="text" onClick={onClick} className={styles.favoriteButton}>
    <Icon type={value ? 'heartfilled' : 'heart'} size={24} color="whiteColor" />
  </Button>
)

FavoriteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
}

export default React.memo(FavoriteButton)
